__turbopack_context__.v({
  "container": "advanced-search-module-scss-module__X9oIVa__container",
  "searchQuery": "advanced-search-module-scss-module__X9oIVa__searchQuery",
  "submitButton": "advanced-search-module-scss-module__X9oIVa__submitButton",
  "subtitle": "advanced-search-module-scss-module__X9oIVa__subtitle",
  "suggestion": "advanced-search-module-scss-module__X9oIVa__suggestion",
});
